import { useMemo } from "react";
import { Provider } from "react-redux";
import OpportunitiesPurchase from "./OpportunitiesPurchase";

const OpportunitiesPurchaseApp = () => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);
  return (
    <Provider store={store}>
      <OpportunitiesPurchase />
    </Provider>
  );
};

export default OpportunitiesPurchaseApp;
